var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combine } from 'zustand/middleware';
export var customActions = function (initialValues) {
    return combine(initialValues, function (setState) { return ({
        setUnreadMessagesCount: function (value) {
            setState(function (state) { return (__assign(__assign({}, state), { content: __assign(__assign({}, state.content), { unreadMessagesCount: value }) })); });
        },
        incrementUnreadMessagesCount: function () {
            setState(function (state) { return (__assign(__assign({}, state), { content: __assign(__assign({}, state.content), { unreadMessagesCount: state.content.unreadMessagesCount + 1 }) })); });
        },
    }); });
};
